// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"softwareCard-module--card-wrapper--3K_lD","cardFooter":"softwareCard-module--card-footer--1mpRK"};